<template>
  <div class="gatewaymanager-container">
    <el-card class="box-card">
      <template #header>
        <div class="card-header">
          <span>{{ $t("message.gateway.title") }}</span>
          <el-button v-if="canAddDeviceGateway" type="primary" @click="handleAdd">{{
            $t("message.gateway.add")
          }}</el-button>
        </div>
      </template>

      <!-- 查询表单 -->
      <el-form :inline="true" :model="queryParams" class="search-form">
        <el-form-item :label="$t('message.gateway.company')" prop="company_id">
          <el-tree-select
            v-model="formData.company_id"
            :data="companyTreeData"
            :props="treeProps"
            :placeholder="$t('message.gateway.selectCompany')"
            check-strictly
            clearable
            filterable
            style="width: 200px"
            @change="handleCompanyChange"
          />
        </el-form-item>

        <el-form-item :label="$t('message.gateway.name')">
          <el-input
            v-model="queryParams.name"
            :placeholder="$t('message.gateway.inputName')"
            clearable
            @change="handleNameInput"
          />
        </el-form-item>
        <el-form-item
          v-if="isColumnVisible"
          :label="$t('message.gateway.status')"
        >
          <el-select
            v-if="isColumnVisible"
            v-model="displayState"
            :placeholder="$t('message.gateway.selectStatus')"
            clearable
            style="width: 120px"
            @change="handleStateChange"
          >
            <el-option :label="$t('message.gateway.all')" :value="0" />
            <el-option :label="$t('message.gateway.offline')" :value="1" />
            <el-option :label="$t('message.gateway.online')" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">{{
            $t("message.common.search")
          }}</el-button>
          <el-button @click="resetQuery">{{
            $t("message.gateway.reset")
          }}</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table
        :data="gatewayList"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          v-if="isColumnVisible"
          prop="id"
          :label="$t('message.gateway.id')"
          width="80"
          sortable
        />
        <el-table-column
          prop="name"
          :label="$t('message.gateway.name')"
          width="150"
          sortable
        />
        <el-table-column
          prop="company_name"
          :label="$t('message.gateway.company')"
          width="150"
          sortable
        />
        <el-table-column
          prop="imei"
          :label="$t('message.gateway.imei')"
          width="180"
          sortable
        />
        <el-table-column
          prop="sn"
          :label="$t('message.gateway.sn')"
          width="180"
          sortable
        />
        <el-table-column
          prop="facturer_name"
          :label="$t('message.gateway.manufacturer')"
          width="120"
          sortable
        />
        <el-table-column
          v-if="isColumnVisible"
          :label="$t('message.gateway.status')"
          width="100"
          sortable
        >
          <template #default="{ row }">
            <el-tag :type="row.state === 1 ? 'success' : 'danger'">
              {{
                row.state === 1
                  ? $t("message.gateway.online")
                  : $t("message.gateway.offline")
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="protocol_name"
          :label="$t('message.gateway.protocol')"
          width="120"
          sortable
        /> 
        <el-table-column prop="created_at" :label="$t('message.gateway.createTime')" width="180" sortable />

<!--         <el-table-column :label="$t('message.gateway.createTime')" width="180" sortable>
          <template #default="{ row }">
            {{ formatDate(row.created_at) }}
          </template>
        </el-table-column> -->
        <el-table-column
          :label="$t('message.gateway.actions')"
          width="180"
          fixed="right"
        >
          <template #default="{ row }">
            <el-button v-if="canEditDeviceGateway" size="small" @click="handleEdit(row)">{{
              $t("message.gateway.edit")
            }}</el-button>
            <el-button v-if="canDeleteDeviceGateway" size="small" type="danger" @click="handleDelete(row)">{{
              $t("message.gateway.delete")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          v-model:current-page="queryParams.pageNum"
          v-model:page-size="queryParams.pageSize"
          :total="total"
          :page-sizes="[5, 10, 15, 20, 30]"
          :layout="'total, sizes, prev, pager, next, jumper'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      v-model="dialogVisible"
      :title="dialogTitle"
      width="50%"
      @closed="resetForm"
    >
      <el-form
        ref="formRef"
        :model="formData"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item :label="$t('message.gateway.company')" prop="company_id">
          <el-tree-select
            v-model="formData.company_id"
            :data="companyTreeData"
            :props="treeProps"
            :placeholder="$t('message.gateway.selectCompany')"
            check-strictly
            clearable
            filterable
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item :label="$t('message.gateway.name')" prop="name">
          <el-input
            v-model="formData.name"
            :placeholder="$t('message.gateway.inputName')"
          />
        </el-form-item>
        <el-form-item :label="$t('message.gateway.imei')" prop="imei">
          <el-input
            v-model="formData.imei"
            :placeholder="$t('message.gateway.imeiRequired')"
          />
        </el-form-item>
        <el-form-item :label="$t('message.gateway.sn')" prop="sn">
          <el-input
            v-model="formData.sn"
            :placeholder="$t('message.gateway.snRequired')"
          />
        </el-form-item>
        <el-form-item
          :label="$t('message.gateway.description')"
          prop="description"
        >
          <el-input
            v-model="formData.description"
            type="textarea"
            :placeholder="$t('message.gateway.inputDescription')"
          />
        </el-form-item>
        <el-form-item
          :label="$t('message.gateway.manufacturer')"
          prop="facturer_id"
        >
          <el-select
            v-model="formData.facturer_id"
            :placeholder="$t('message.gateway.selectManufacturer')"
            style="width: 100%"
          >
            <el-option
              v-for="item in manufacturerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('message.gateway.protocol')"
          prop="protocol_id"
        >
          <el-select
            v-model="formData.protocol_id"
            :placeholder="$t('message.gateway.selectProtocol')"
            style="width: 100%"
          >
            <el-option
              v-for="item in protocolOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">{{
            $t("message.gateway.cancel")
          }}</el-button>
          <el-button type="primary" @click="submitForm">{{
            $t("message.gateway.confirm")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import {
  getGatewayList,
  addGateway,
  updateGateway,
  deleteGateway,
} from "@/api/GatewayManager";
import { getCompanyTree } from "@/api/CompanyManager";
import { usePermission } from '@/composables/usePermission'

const {  canAddDeviceGateway,canEditDeviceGateway,canDeleteDeviceGateway } = usePermission()
   
const { t } = useI18n();

// 数据列表
const gatewayList = ref([]);
const loading = ref(false);
const total = ref(0);
const companyTreeData = ref([]);
const displayState = ref(0); // 显示用的值（0=全部，1=离线，2=在线）

// 树形配置
const treeProps = {
  value: "id",
  label: "name",
  children: "children",
};

// 查询参数
const queryParams = reactive({
  companyId: 0,
  name: null,
  state: null, // 实际查询参数（null=全部，0=离线，1=在线）
  facturerId: null,
  protocolId: null,
  benTime: null,
  endTime: null,
  pageNum: 1,
  pageSize: 10,
});

//查询企业树
const queryCompanyTreeParams = reactive({
  companyId: null,
});

// 表单数据
const formData = reactive({
  id: 0,
  name: "",
  company_id: 0,
  //company_name: '',
  imei: "",
  sn: "",
  description: "",
  facturer_id: 1,
  //facturer_name: '',
  state: 0,
  protocol_id: 1,
  //protocol_name: '',
  created_at: undefined,
});


// 表单验证规则
const rules = reactive({
  name: [
    {
      required: true,
      message: t("message.gateway.nameRequired"),
      trigger: "blur",
    },
  ],
  company_name: [
    {
      required: true,
      message: t("message.gateway.companyRequired"),
      trigger: "blur",
    },
  ],
  imei: [
    {
      required: true,
      message: t("message.gateway.imeiRequired"),
      trigger: "blur",
    },
  ],
  sn: [
    {
      required: true,
      message: t("message.gateway.snRequired"),
      trigger: "blur",
    },
  ],
  facturer_id: [
    {
      required: true,
      message: t("message.gateway.manufacturerRequired"),
      trigger: "change",
    },
  ],
  protocol_id: [
    {
      required: true,
      message: t("message.gateway.protocolRequired"),
      trigger: "change",
    },
  ],
});

// 厂家类型选项
const manufacturerOptions = [
  { value: 1, label: t("message.gateway.manufacturer1") },
  { value: 2, label: t("message.gateway.manufacturer2") }  
];

// 协议类型选项
const protocolOptions = [
  { value: 1, label: "MQTT" },
  { value: 2, label: "TCP" },
];

// 对话框控制
const dialogVisible = ref(false);
const dialogTitle = ref("");
const formRef = ref();

onMounted(async () => {
 await loadCompanyTree(queryCompanyTreeParams);
 await handleQuery();
  //getList()
});

// 初始化时同步显示状态
watch(
  () => queryParams.state,
  (newVal) => {
    displayState.value = newVal === null ? 0 : newVal + 1;
  },
  { immediate: true }
);

// 获取企业树
const loadCompanyTree = async (params) => {
  try {
    const res = await getCompanyTree(params);
    companyTreeData.value = res.data.list;
    if (companyTreeData.value.length > 0) {
      formData.company_id = companyTreeData.value[0].id;
      queryParams.companyId = formData.company_id;
    }
  } catch (error) {
    ElMessage.error(t("message.gateway.loadCompanyFailed"));
  }
};

// 企业选择变化
const handleCompanyChange = (selectedCompanyId) => {
  queryParams.companyId = selectedCompanyId;
};

// 名称变化
const handleNameInput = (value) => {
  queryParams.name = value || null;
};

// 状态变化
const handleStateChange = (value) => {
  queryParams.state = value === 0 ? null : value - 1;
};

// 获取网关列表
const getList = async () => {
  try {
    if (!queryParams.companyId || queryParams.companyId <= 0) {
      ElMessage.warning(t("message.template.selectCompanyFirst"));
      return;
    }

    loading.value = true;
    const res = await getGatewayList(queryParams);
    if(res.success)
    {
        // 在赋值前格式化时间字段
        const formattedList = res.data.list.map(item => ({
          ...item,
          created_at: formatDate(item.created_at),
          // 如果有其他时间字段也需要格式化
          // updated_at: formatDate(item.updated_at)
        }));

        gatewayList.value = formattedList;

        //gatewayList.value = res.data.list;
        total.value = res.data.totalCount;
    }
    else
    {
      ElMessage.warning(res?.msg);
    }
    
  } catch (error) {
    ElMessage.error(error.message || t("message.gateway.loadDataFailed"));
  } finally {
    loading.value = false;
  }
};

// 查询
const handleQuery = () => {
  queryParams.pageNum = 1;
  getList();
};

// 重置查询
const resetQuery = () => {
  queryParams.pageNum = 1;
  queryParams.name = null;
  queryParams.state = null;
  getList();
};

// 分页大小变化
const handleSizeChange = (val) => {
  queryParams.pageSize = val;
  getList();
};

// 当前页变化
const handleCurrentChange = (val) => {
  queryParams.pageNum = val;
  getList();
};

// 日期格式化
/* const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleString();
}; */
// 日期格式化
const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .format(date)
    .replace(/\//g, "-") // 将斜杠替换为横杠
    .replace(/(\d+):(\d+):(\d+)/, "$1:$2:$3"); // 保持时间格式
};

// 新增网关
const handleAdd = () => {
  dialogTitle.value = t("message.gateway.addTitle");
  dialogVisible.value = true;
};

// 编辑网关
const handleEdit = (row) => {
  dialogTitle.value = t("message.gateway.editTitle");
  Object.assign(formData, row);
  dialogVisible.value = true;
};

// 删除网关
const handleDelete = (row) => {
  ElMessageBox.confirm(
    t("message.gateway.deleteConfirm"),
    t("message.gateway.tip"),
    {
      confirmButtonText: t("message.gateway.confirm"),
      cancelButtonText: t("message.gateway.cancel"),
      type: "warning",
    }
  )
    .then(async () => {
      try {
        const requestData = {
          id: row.id
        };
        const res = await deleteGateway(requestData);        
        if(res?.success)
        {
            ElMessage.success(t("message.gateway.deleteSuccess"));
            getList();
        }
        else
        {
            ElMessage.warning(res?.msg);
        }
                
      } catch (error) {
        ElMessage.error(error.message || t("message.gateway.deleteFailed"));
      }
    })
    .catch(() => {
      ElMessage.info(t("message.gateway.deleteCancelled"));
    });
};

/*const formatTimeSend = (dateString) => {
  if (!dateString) return '';
  return dateString.replace(' ', 'T');
};*/

// 提交表单
const submitForm = async () => {
  try {
    await formRef.value.validate();

    if (formData.id) {
      formData.created_at = undefined;
      const requestData = { ...formData };
      const res = await updateGateway(requestData);
      if(!res?.success)
      {
          ElMessage.warning(res?.msg); 
      }
      else
      {
          ElMessage.success(t("message.gateway.updateSuccess"));
      }
      
    } else {
      const requestData = [{ ...formData }];
      const res = await addGateway(requestData);
      if(!res?.success)
      {
          ElMessage.warning(res?.msg); 
      }
      else
      {
        ElMessage.success(t("message.gateway.addSuccess"));
      }
      
    }

    dialogVisible.value = false;
    getList();
  } catch (error) {
    console.error("表单验证或提交失败:", error);
  }
};

// 重置表单
const resetForm = () => {
  formRef.value?.resetFields();
  Object.assign(formData, {
    id: 0,
    name: "",
    company_id: 0,
    //company_name: '',
    imei: "",
    sn: "",
    description: "",
    facturer_id: 1,
    //facturer_name: '',
    state: 0,
    protocol_id: 1,
    //protocol_name: '',
    created_at: null,
  });
  loadCompanyTree(queryCompanyTreeParams);
};
</script>

<style scoped>
.gatewaymanager-container {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
